/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import AdministrationTab from 'components/Tabs';
import { routePath } from 'constants/route.constants';
import AtsMappingPage from 'container/AtsMappingPage';
import InviteToApplyPage from 'container/InviteToApply';
import LandingPage from 'container/LandingPage';
import SearchSettingsPage from 'container/SearchSettings';
import ConsentPage from 'pages/consent-page';
import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/naming-convention

const _Routes = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const location = useLocation();

  return (
    <Routes>
      {' '}
      {/* Dashboard Routings */}
      <Route key='kfone-kfnr-cms1' path={'/'} element={<AdministrationTab />} />
      <Route key='kfone-kfnr-cms' path={'/home'} element={<AdministrationTab />} />
      <Route key='consent' path={'/consent'} element={<ConsentPage />} />
      <Route key='search-settings' path={'/search-settings'} element={<SearchSettingsPage />} />
      <Route key='ats-mapping' path={'/ats-mapping'} element={<AtsMappingPage />} />
      <Route key='invite-apply' path={'/invite-apply'} element={<InviteToApplyPage />} />
    </Routes>
  );
};

export default _Routes;
